import { lazyLoad } from 'utils/loadable';

export const AutoTaskManagementPageLoadable = lazyLoad(
  () => import('./index'),
  module => module.AutoTaskManagementPage,
);
